import { http } from '../http';
import { PropertiesType } from 'V2/Types';

export const getAnalytics = (): Promise<{ data: PropertiesType }> =>
  http.get({
    url: `/api/v1/insurance_applications/${sessionStorage.getItem(
      'appId'
    )}/analytics`,
  });
